import { render, staticRenderFns } from "./examAudio.vue?vue&type=template&id=1f13d2e6&scoped=true"
import script from "./examAudio.vue?vue&type=script&lang=js"
export * from "./examAudio.vue?vue&type=script&lang=js"
import style0 from "./examAudio.vue?vue&type=style&index=0&id=1f13d2e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f13d2e6",
  null
  
)

export default component.exports